import React, { useEffect } from 'react'
import { useAppSelector } from '../../../store/hooks'
import { selectSafeAuthenticatedUser } from '../../../store/auth/authSlice'
import { YesNoCancelModal } from '../../Modal/YesNoCancelModal'
import { Button } from '../../Button/Button'
import { PresetConfigLoader } from '../../../views/Setup/AIFeaturePresets/PresetConfig/Common/PresetConfigLoader'
import { ScopedBlock } from '../../ScopedBlock/ScopedBlock'
import { MissingScopeAction } from '../../ScopedBlock/models'
import { useMeetingTemplateEffectiveInputParameters, useInputParametersUpdateScope, useEmailTypeEffectiveInputParameters } from '../hooks'
import {
  EmailTypeInputParametersHierarchyConfigComponentProps,
  InputParameterHierarchyType,
  MeetingTemplateInputParametersHierarchyConfigComponentProps,
} from '../model'
import { TemplateBox } from '../../TemplateBox/TemplateBox'
import { useUserTemplateConfigForm } from '../../../views/Setup/AIFeaturePresets/PresetConfig/Template/Hierarchy/hooks'
import { TemplateInputParameters } from '../../../models/AiFeature'
import { CurrentUserConfigFormBody } from './CurrentUserConfigFormBody'

export const EmailTypeCurrentUserTemplateInputParameterConfigForm: React.FC<EmailTypeInputParametersHierarchyConfigComponentProps> = ({
  type,
  typeId,
  inputParametersSchema,
  defaultInputParameters,
  emailTypeId,
  showCustomizationSetting,
  onHide,
  ipHierarchyEnabled,
}) => {
  const { id: currentUserId } = useAppSelector(selectSafeAuthenticatedUser)
  const { inputParameters, parentInputParameters, updateLoading, updateInputParameters, isCustomized } = useEmailTypeEffectiveInputParameters(
    type,
    typeId,
    defaultInputParameters,
    currentUserId,
    emailTypeId,
  )

  if (!inputParameters || !parentInputParameters) {
    return <PresetConfigLoader />
  }

  return (
    <CurrentUserConfigFormBody
      type={type}
      typeId={typeId}
      inputParametersSchema={inputParametersSchema}
      inputParameters={{ example_1: '', example_2: '', template: inputParameters.template }}
      defaultInputParameters={{ example_1: '', example_2: '', template: defaultInputParameters?.template ?? '' }}
      parentInputParameters={{ example_1: '', example_2: '', template: parentInputParameters.template }}
      isCustomized={isCustomized}
      showCustomizationSetting={showCustomizationSetting}
      onSave={updateInputParameters}
      onHide={onHide}
      updateLoading={updateLoading}
      ipHierarchyEnabled={ipHierarchyEnabled}
    />
  )
}
